import React from 'react'
import { bind } from '@src/utils'
import { ILoginViewModel, LoginViewModel } from './login.view-model'
import { Form } from 'react-bootstrap'
import './style.scss'

function LoginPage({ handleOnSubmit, register, errors }: ILoginViewModel) {
  return (
    <div className='login-page'>
      <div className='content-wrap'>
        <div className='content'>
            <div className='form'>
              <h1 className='title'>PIO雲端管理系統</h1>
              <label className='account-wrap'>
                <span>帳號</span>
                <Form.Control
                  placeholder='請輸入帳號'
                  {...register('account')}
                />
                {errors.account && <Form.Text className='text-danger'>{errors.account.message}</Form.Text>}
              </label>
              <label className='password-wrap'>
                <span>密碼</span>
                <Form.Control
                  placeholder='請輸入密碼'
                  type='password'
                  {...register('password')}
                />
                {errors.password && <Form.Text className='text-danger'>{errors.password.message}</Form.Text>}
              </label>
              <hr />
              <a onClick={handleOnSubmit}>
                登入
              </a>
            </div>
        </div>
      </div>
    </div>
  )
}

export default bind(LoginPage, LoginViewModel)
